/* eslint-disable camelcase */
/*
 * flashmeeting-fe
 *
 * Author: Andgel BRISSAUD
 * Copyright (c) 2024 Prodeo - All Rights Reserved
 */

/* ===== External Libraries ===== */
import { CallbackErrorAxios, CallbackWarningAxios, CommonGlobalService, configService, UUID } from '@umanforge/common';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

/* ===== API Configuration ===== */
import { API } from 'constants/api.constant';

/* ===== Services ===== */
import { GlobalService } from './global.service';

/* ===== Interfaces ===== */
export interface ResolutionPlanData {
  title: string;
  pilote: {
    id: UUID;
    firstname: string;
    lastname: string;
    email: string;
  }
  site: {
    id: UUID;
    name: string;
  };
  flashMeetingId: UUID;
  tool6w: {
    descWho: string;
    descWhat: string;
    descWhere: string;
    descWhen: string;
  };
}

interface ResolutionPlanResponse { id: UUID; }

export class ResolutionService {

  /* ===== Send request to create a resolution plan ===== */
  static createResolutionPlan(
    userId: string,
    resolutionData: ResolutionPlanData,
    token: string | null,
    dispatch: Dispatch,
    onError?: CallbackErrorAxios,
    onWarning?: CallbackWarningAxios
  ): Promise<ResolutionPlanResponse | undefined> {
    return new Promise( async resolve => {
      const body = {
        title: resolutionData.title,
        pilote: resolutionData.pilote,
        site: resolutionData.site,
        flash_meeting_id: resolutionData.flashMeetingId,
        tool_6w: {
          desc_who: resolutionData.tool6w.descWho,
          desc_what: resolutionData.tool6w.descWhat,
          desc_where: resolutionData.tool6w.descWhere,
          desc_when: resolutionData.tool6w.descWhen,
        }
      };

      const customAxios = axios.create( { baseURL: await configService.getResolutionBackEndUrl() } );

      customAxios.post<ResolutionPlanResponse>(
        `${API.RESOLUTION_PLAN}?user-id=${userId}`,
        body,
        await CommonGlobalService.getHeaderRequest( token )
      )
        .then( ( response: AxiosResponse<ResolutionPlanResponse> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( undefined );
        } );
    } );
  }

}
